import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Typography, Stack, Button, TextField, Alert } from '@mui/material';
import { getLatestFormAction } from '../../../services/request';
import { FormPanel } from '../../../components/form/FormPanel';
import { useResponsive } from '../../../services/hooks';
import { Header } from '../../../components/landing/Header';

const ZieloneSzkolyFormPage = ({ formIdentifier, year, validPassword }) => {
  const { loading, payload, error } = useQuery(getLatestFormAction(formIdentifier, year));
  const [form, setForm] = React.useState(null);
  const [isPasswordValid, setIsPasswordValid] = React.useState(false);
  const [invalidPassword, setInvalidPassword] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const isDesktop = useResponsive('up', 'lg');
  const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';

  const handleChange = e => setPassword(e.target.value);

  const handleClick = e => {
    if (password === validPassword) {
      setIsPasswordValid(true);
    } else {
      setInvalidPassword(true);
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
    }

  }, [loading]);

  // --- Google Tag Manager ---
  React.useEffect(() => {
    if (!isProduction) {
      return;
    }
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? `&l=${l}` : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', 'GTM-NP5WQG26'));

    // noscript fallback
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-NP5WQG26';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  // --- END Google Tag Manager ---

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  return (
    <>
      <Header isDesktop={isDesktop} redirectUrl="http://zielone-szkoly.com/" />
      {form != null
        ? <>
          {!isPasswordValid ? <Stack justifyContent="center" alignItems="center" spacing={4} mt={8}>
            <TextField
              label={'Hasło'}
              placeholder="Podaj hasło"
              type="password"
              onChange={handleChange}
              value={password}
              sx={{ width: '300px' }}
            />
            {invalidPassword ? <Alert severity="error" sx={{ width: '300px' }}>niepoprawne hasło</Alert> : null}
            <Button variant="contained" onClick={handleClick} sx={{ width: '300px' }}>pokaż formularz</Button>
          </Stack> : null}
          {isPasswordValid ? <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
            <FormPanel form={form} />
          </div> : null}
        </>
        : null}
    </>
  );
};

export default ZieloneSzkolyFormPage;
